


























































































































































































































































import { ContractTypeEnum } from "@/lib/enum/contract-type.enum";
import { handleError } from "@/lib/utility/handleError";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Contract, IContract } from "@/models/contract.entity";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { mixins } from "vue-class-component";
import { Component, Prop, Watch } from "vue-property-decorator";
import CustomFieldBoolean from "../report/CustomFieldBoolean.vue";
import TemplateEditor from "../template/TemplateEditor.vue";
import RefsSelectForm from "../utility/RefsSelectForm.vue";
import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { numberLowerRule } from "@/lib/rules/numberLowerRule";

@Component({
  components: {
    TemplateEditor,
    RefsSelectForm,
    CustomFieldBoolean
  }
})
export default class ContractDetailsForm extends mixins(RulesMixin) {
  @Prop({ required: true }) contract!: IContract;
  @Prop({ default: false }) valid!: boolean;

  local: IContract = new Contract({});
  original: IContract = new Contract({});
  localValid = false;
  isEditing = false;
  loading = false;

  readonly contracTypeEnum = ContractTypeEnum;

  readonly ResourceEnum = ResourceEnum;

  @Watch("contract", { immediate: true, deep: true })
  onContractChange(val: IContract) {
    this.local = new Contract(val);
    this.original = new Contract(val);
  }

  @Watch("localValid")
  onLocalValid(val: boolean) {
    this.$emit("update:valid", val);
  }

  @Watch("valid")
  onExternalValid(val: boolean) {
    if (val !== this.localValid) {
      this.localValid = val;
    }
  }

  get greaterThanZeroRule() {
    return [numberHigherRule(0)];
  }

  get isRelativeValueRule() {
    return [numberHigherRule(0), numberLowerRule(100)];
  }

  cancelEdit() {
    this.local = new Contract(this.original);
    this.isEditing = false;
  }

  async update() {
    this.loading = true;
    try {
      await this.local.update();
      this.$emit("updated", this.local);
      this.original = new Contract(this.local);
      this.isEditing = false;
      this.$toast.success("👍");
    } catch (e) {
      handleError(e);
    } finally {
      this.loading = false;
    }
  }
}
